import React from 'react';
import { Stack } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';

import PaiTextField from 'features/ui/base-components/pai-text-field';
import { BasicActionDialog } from 'features/ui/base-dialogs';

interface Props {
  open: boolean;
  loading: boolean;
  email: string;

  handleEmailChange(event: React.ChangeEvent<HTMLInputElement>): void;
  handleClose(): void;
  handleEditEmail(): void;
}

const EditContactEmailDialog: React.FC<Props> = ({
  open,
  loading,
  email,
  handleEmailChange,
  handleClose,
  handleEditEmail
}) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <BasicActionDialog
      open={open}
      loading={loading}
      dialogTitle={t('editContactEmail')}
      maxWidth="xs"
      proceedButtonText={t('save')}
      handleProceed={handleEditEmail}
      proceedButtonDisabled={email.trim() === ''}
      cancelButtonText={t('cancel')}
      handleClose={handleClose}
    >
      {/* 
        If you need extra spacing or structure, wrap in Stack. 
        But here there's only one field, so it's optional.
      */}
      <Stack spacing={2} className={classes.dialogContent}>
        <PaiTextField
          label={t('email')}
          placeholder={t('enterContactEmailHere')}
          value={email}
          onChange={handleEmailChange}
        />
      </Stack>
    </BasicActionDialog>
  );
};

const useStyles = makeStyles()(() => ({
  dialogContent: {
    // e.g. marginTop: theme.spacing(1),
  }
}));

export default EditContactEmailDialog;
